export const attendanceGps = {
    assignmentObjects : "assignmentObjects",
    description : "description",
    name : "name",
    address : "address",
    radius : "radius",
    status : "status",
    type : "type",
    boundingBox : "boundingBox",
}

export const STATUS_CODE = {
    OVER_QUERY_LIMIT : "OVER_QUERY_LIMIT"
}

export const lat_lng = {
    lat: 21.028511,
    lng: 105.804817,
}

export const DEFAULT_RADIUS = 250

export const API_KEY_MAP_GG = "AIzaSyBDWa2nZHfQLq73ESQz23k1EzaLQq8I-jM"
export const PLACE_API = "PLACE_API"
export const MAPS_JAVASCRIPT_API = "MAPS_JAVASCRIPT_API"
export const TOTAL_LIMIT = 920
export const PLACE_API_REQUEST = {
    "apiKey": API_KEY_MAP_GG,
    "type": PLACE_API
}